import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import logo from "../images/logo_transparent.png";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import HospitalLogin from "./HospitalLogin/HospitalLogin";
import MainRoute from './Route';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  nav_bgc: {
    backgroundColor: "#00416d",
  },
  logo: {
    height: "40px",
    padding: "10px",
  },
}));

// const hospitalLoginHandler = () => {
//   <Router>
//     <Link className="buttonLink" to={"/hospital-login"}></Link>;
//     <Switch>
//       <Route path="/hospital-login" component={HospitalLogin} />
//     </Switch>
//   </Router>;
// };

function Nav() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar className={classes.nav_bgc} position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu">
            <MenuIcon />
          </IconButton>

          <img className={classes.logo} src={logo} alt="logo" />

          <Typography variant="h6" className={classes.title}>
            WeWin
          </Typography>
          <Button color="inherit">Get Started</Button>

          <Button
            color="inherit"
            className="buttonLink"
             href="/hospital-login"
            >
                      Logout
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Nav;
